<template>
    <div class="csv-upload">
        <pendo-button
            v-if="!tagId"
            theme="app"
            type="secondary"
            class="upload-button"
            label="Upload CSV"
            @click="openModal" />
        <pendo-tag
            v-if="tagId"
            class="csv-upload__tag"
            type="filter"
            :closable="true"
            :label="filename"
            @close="removeFile" />
        <csv-upload-modal
            :visible="showUploadModal"
            :kind="kind"
            :metadata-field="metadataField"
            @cancel="closeModal"
            @close="setEntityTag" />
    </div>
</template>

<script>
import { PendoButton, PendoTag } from '@pendo/components';
import CsvUploadModal from '@/segments/components/segment-editor-vue/components/csv-upload-modal.vue';

export default {
    name: 'CsvUpload',
    components: {
        CsvUploadModal,
        PendoButton,
        PendoTag,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        kind: {
            type: String,
            required: true,
        },
        metadataField: {
            type: String,
            default: null,
        },
    },
    emits: ['input'],
    data () {
        return {
            showUploadModal: false,
        };
    },
    computed: {
        tagId () {
            return this.value.tagId;
        },
        filename () {
            return this.value.value || 'csv';
        },
    },
    methods: {
        removeFile () {
            this.$emit('input', {
                field: ['tagId', 'value'],
                value: {
                    tagId: null,
                    value: null,
                },
            });
        },
        openModal () {
            this.showUploadModal = true;
        },
        closeModal () {
            this.showUploadModal = false;
        },
        setEntityTag (entityTag) {
            this.$emit('input', {
                field: ['tagId', 'value', 'analyticsDelayedAtTimestamp'],
                value: entityTag,
            });
            this.closeModal();
        },
    },
};
</script>

<style scoped lang="less">
.csv-upload {
    display: flex;
    align-items: center;

    .csv-upload__tag {
        text-transform: unset !important;
    }

    &[invalid] {
        .upload-button {
            border: 1px solid var(--palette-pink-110);
        }
    }
}
</style>
